import { useEffect, useState } from "react";

const ImageFilePreview = ({
  alt,
  style,
  className = "",
  showFallback = true,
  key,
  img = null,
}) => {
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    if (img) {
      setImageUrl(img);
    } else {
      setImageUrl(null);
    }
  }, [img]);

  if (!imageUrl) {
    return showFallback ? (
      <div
        className={className}
        style={{
          ...style,
          width: "70%",
          height: "80%",
          borderRadius: "50%",
          backgroundColor: "#ccc",
          display: "inline-block",
        }}
      />
    ) : null;
  }

  return (
    <img
      key={key}
      src={imageUrl}
      alt={alt}
      className={className}
      style={{ ...style }}
      onError={() => {
        setImageUrl(null);
      }}
    />
  );
};

export default ImageFilePreview;
